export default __webpack_public_path__ + "static/media/ic-social-fb.f2e35e1c.svg";